var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:_vm.props.light?'hometitle hometitle-light':'hometitle'},[_c('hr'),_c('h1',[_vm._v(_vm._s(_vm.props.title))]),_c('span',{staticClass:"hometitle-description"},[_vm._v(_vm._s(_vm.props.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }